import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const Content = (props) => {
  return (
    <div>
      <div className='p-3'>
        {props.data.steps.length === 1
          ? (<p className='pr-3 m-0'>{props.data.steps[0]}</p>)
          : (
            <ul className='pr-3 m-0' style={{ listStyleType: 'disc' }}>
              {props.data.steps.map((step, i) => <li key={i}>{step}</li>)}
            </ul>)}
        {props.data.isDone > 0 &&
          (
            <div className='d-flex flex-column my-4 justify-content-center align-items-center text-success'>
              <FontAwesomeIcon size='5x' icon={faCheckCircle} />
            </div>
          )}
        {/* <div className='d-flex justify-content-end mt-3'>
        <a type='button' className='btn btn-sm btn-primary' style={{ borderRadius: '4px' }} onClick={() => props.closeTour()}>Ok</a>
      </div> */}
      </div>
    </div>
  )
}

export default Content
